import React from "react";

class InputField extends React.Component {
  render() {
    return (
      <div className="inputField">
        <input
          required={this.props.required ? true : false}
          className="input"
          type={this.props.type}
          placeholder={this.props.placeholder}
          value={this.props.value}
          onChange={(e) => this.props.onChange(e.target.value)}
          onKeyDown={(e) => this.props.onKeyDown(e)}
          disabled={this.props.disabled ? true : false}
          readOnly={this.props.readOnly || false}
          name={this.props.name}
          min={this.props.min}
          max={this.props.max}
        />
      </div>
    );
  }
}

export default InputField;
